const idPortalApi = "464af9ed4a5517867c94a3d0835a90b881d3d25d";

module.exports = {
  tokenLink: idPortalApi,
  urlApi: `https://api-portais-workcenter.com.br/${idPortalApi}`,
  link: "http://www.transparenciadministrativa.com.br",
  urlADM: `https://administracaopublica.com.br`,
  linkArquivos: "http://www.transparenciadministrativa.com.br/portalimagem",
  imagemURL: "https://cdn.administracaopublica.com.br/complementares/",

  // urlApi: `http://localhost:8004/${idPortalApi}`,
  //imagemURL: 'http://localhost:8004/uploads/', //link para a imagem

  urlEmDeploy: "https://cmmaranhaozinho.ma.gov.br/", //usada para link de compartilhamento
  dnsPortal: "cmmaranhaozinho.ma.gov.br",
  NomePortal: "Maranhãozinho",
  ufPortal: "MA",
  NomeTipoPortal: "Câmara Municipal", //Prefeitura ou Câmara
  TipoPortal: 4, //3 = Prefeitura 4 = Câmara

  //Variável em teste (newsViewRoute)
  newsViewRoute: true,
  countNewsHome: 12, //quantidade de noticias na home
  RoutesDaily: true, //Deixa ativado as rotas para a pagina de diario
  corIcones: "#b28e08",

  //links externos
  link_youtube: `https://www.youtube.com/@poderlegislativomaranh%C3%A3ozinho`,
  link_tiktok: `#`,
  link_twitter: `#`,
  link_threads: `#`,
  link_localize: `https://maps.app.goo.gl/TZPchvxst5C3uSRQ6`,
  //Mapa da pagina Municipio/Mapa
  link_mapa:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15947.039513312298!2d-45.860352944183546!3d-2.2435664779391193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92b3b6bd475c177d%3A0x18ea5596345abc95!2sMaranh%C3%A3ozinho%2C%20State%20of%20Maranh%C3%A3o%2C%2065283-000!5e0!3m2!1sen!2sbr!4v1750970154374!5m2!1sen!2sbr",
};
